// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.vocabulary-quest-beta-workspace .cva-target{font-weight:bold;text-decoration:underline}`, "",{"version":3,"sources":["webpack://./assets/src/scripts/components/routes/student-cva-workspace.vue"],"names":[],"mappings":"AAEC,6CACC,gBAAA,CACA,yBAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
